import React from 'react';
import { getAssetsUrl } from '@gik/core/utils/LinkUtils';
import { SignupCallout } from '@gik/auth';
import { ISignupCalloutProps } from '@gik/auth/components/Signup/SignupCallout';
import { useBemCN } from '@gik/core/utils/bemBlock';

export interface ISignupCalloutUpdatesProps {
  recipientName: string;
}

export default function SignupCalloutUpdates({ recipientName }: ISignupCalloutUpdatesProps) {
  const bem = useBemCN('signup-callout-updates');

  const values: ISignupCalloutProps = {
    mdBackgroundImageUrl: `${getAssetsUrl()}auth/img/SignupCalloutUpdates/updates.png`,
    mdDownBackgroundImageUrl: `${getAssetsUrl()}auth/img/SignupCalloutUpdates/updates-mobile.png`,
    title: 'Stay in the loop!',
    subtitle: `Get notified when updates are posted from this page, so you know how best to support <span class="tw-font-bold">${recipientName}</span> in the future.`,
    imageUrl: `${getAssetsUrl()}auth/img/SignupCalloutUpdates/updates-example.svg`,
    imageAlt: 'User updates example',
    ...bem(),
  };

  return <SignupCallout {...values} />;
}
